import { Banner, Button, Typography } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";

import logo from "@/assets/logo.svg";
import useOutboundQueryParams from "@/hooks/useOutboundQueryParams";
import useSegmentEvent from "@/hooks/useSegmentEvent";

type PublicReviewBannerProps = {
  companyName: string;
};

export default function PublicReviewBanner({
  companyName,
}: PublicReviewBannerProps) {
  const { t } = useTranslation(["review"]);
  const outboundQueryParams = useOutboundQueryParams("bilanpublic");

  const { sendSegmentEvent } = useSegmentEvent();

  return (
    <Banner className="gap-y-xs sm:gap-x-2xs mt-sm flex flex-col items-start gap-x-0 sm:flex-row sm:items-center">
      <div className="gap-2xs flex items-center">
        <img src={logo} className="size-md sm:size-md" />
        <Typography step="-1" weight="semibold" className="mt-2xs sm:mt-0">
          {t("review:banner.public.title", { companyName })}
        </Typography>
      </div>
      <div className="gap-2xs sm:gap-2xs mt-2xs flex w-full flex-col sm:mt-0 sm:ml-auto sm:w-auto sm:flex-row">
        <Button
          intent="secondary"
          as="a"
          href={`https://www.hellocarbo.com/reservez-votre-demo${outboundQueryParams}`}
          onClick={() => sendSegmentEvent("Demo booked through public review")}
          shouldOpenNewTab
          className="sm:w-auto"
        >
          {t("review:banner.public.primaryAction")}
        </Button>
        <Button
          intent="secondary"
          as="a"
          href="https://pro.hellocarbo.com/"
          onClick={() => sendSegmentEvent("Free trial through public review")}
          shouldOpenNewTab
          className="sm:w-auto"
        >
          {t("review:banner.public.secondaryAction")}
        </Button>
      </div>
    </Banner>
  );
}
